// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/@flaticon/flaticon-uicons/css/all/all.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/background.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sm-page {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat bottom right / auto 40vh, rgb(232, 231, 227);
    width: 100%;
    min-height: 100vh;
    align-items: center;
    justify-content: center;
    font-family: 'Monaco', monospace;
    position: absolute;
    margin: 0;
    padding: 0;
    overflow: auto;
    z-index: 0;
}

.sm-input {
    box-sizing: border-box; 
    width: 100%; 
    padding: 15px;
    margin: 10px 0; 
    background-color: #565656;
    border-radius: 10px; 
    font-family: 'Monaco', monospace;
    color: rgb(255, 255, 255);
}

.sm-container {
    width: 95%;
    margin: 5% auto;
    padding: 2%; 
    background-color: transparent;
    border: none;
    text-align: center;
}

.sm-space-list {
    list-style-type: none;
    padding: 0;
}

.sm-space-info {
    background-color: #333;
    color: #fff;
    padding: 20px;
    border-radius: 8px;
    overflow-x: auto;
    text-align: left;
    margin-bottom: 20px;
}

.sm-space-info-button {
    margin-top: 2%;
    background: #565656;
    color: white;
    padding: 8px 16px;
    font-size: 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s;
}
.sm-space-info-button:hover {
    background-color: #7b7b7b;
}

.sm-space-info-title {
    color: white;
}

.sm-space-container {
    background-color: #444;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 2%;
    cursor: pointer;
}

.sm-space-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.sm-button {
    width: auto;
    margin: 10px;
}

.sm-hub-list2 {
    list-style-type: none;
    padding-left: 20px;
    margin: 0;
}
.sm-sensor-list {
    list-style-type: none;
    padding-left: 20px;
    margin: 0;
}

.sm-hub-info {
    background-color: #565656;
    padding: 10px;
    border-radius: 4px;
    margin-top: 20px;
    color: #ffffff;
    text-align: left;
}

.sm-sensor-info {
    margin-bottom: 10px;
    margin-top: 10px;
    color: #fefefe;
}

/* Header and buttons styles */
.header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    justify-content: flex-start;
}

.sm-hub-list {
    list-style-type: none;
    padding-left: 0;
    margin: 0;
}

/* Popup button styles for EditHub */
.btn-scale-confirm {
    background-color: #b7f88c !important;
    color: black !important;
}
.btn-scale-reset {
    background-color: #ffc445 !important;
    color: black !important;
}
.btn-scale-cancel {
    background-color: #ff2e2e !important;
    color: black !important;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Devices.css"],"names":[],"mappings":"AAEA;IACI,0GAAmG;IACnG,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,cAAc;IACd,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,WAAW;IACX,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,iCAAiC;AACrC;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,SAAS;AACb;;AAEA,oCAAoC;AACpC;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;AACA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;AACA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B","sourcesContent":["@import \"~@flaticon/flaticon-uicons/css/all/all\";\n\n.sm-page {\n    background: url('../assets/background.webp') no-repeat bottom right / auto 40vh, rgb(232, 231, 227);\n    width: 100%;\n    min-height: 100vh;\n    align-items: center;\n    justify-content: center;\n    font-family: 'Monaco', monospace;\n    position: absolute;\n    margin: 0;\n    padding: 0;\n    overflow: auto;\n    z-index: 0;\n}\n\n.sm-input {\n    box-sizing: border-box; \n    width: 100%; \n    padding: 15px;\n    margin: 10px 0; \n    background-color: #565656;\n    border-radius: 10px; \n    font-family: 'Monaco', monospace;\n    color: rgb(255, 255, 255);\n}\n\n.sm-container {\n    width: 95%;\n    margin: 5% auto;\n    padding: 2%; \n    background-color: transparent;\n    border: none;\n    text-align: center;\n}\n\n.sm-space-list {\n    list-style-type: none;\n    padding: 0;\n}\n\n.sm-space-info {\n    background-color: #333;\n    color: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    overflow-x: auto;\n    text-align: left;\n    margin-bottom: 20px;\n}\n\n.sm-space-info-button {\n    margin-top: 2%;\n    background: #565656;\n    color: white;\n    padding: 8px 16px;\n    font-size: 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    transition: background-color 0.3s;\n}\n.sm-space-info-button:hover {\n    background-color: #7b7b7b;\n}\n\n.sm-space-info-title {\n    color: white;\n}\n\n.sm-space-container {\n    background-color: #444;\n    padding: 10px;\n    border-radius: 4px;\n    margin-bottom: 2%;\n    cursor: pointer;\n}\n\n.sm-space-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.sm-button {\n    width: auto;\n    margin: 10px;\n}\n\n.sm-hub-list2 {\n    list-style-type: none;\n    padding-left: 20px;\n    margin: 0;\n}\n.sm-sensor-list {\n    list-style-type: none;\n    padding-left: 20px;\n    margin: 0;\n}\n\n.sm-hub-info {\n    background-color: #565656;\n    padding: 10px;\n    border-radius: 4px;\n    margin-top: 20px;\n    color: #ffffff;\n    text-align: left;\n}\n\n.sm-sensor-info {\n    margin-bottom: 10px;\n    margin-top: 10px;\n    color: #fefefe;\n}\n\n/* Header and buttons styles */\n.header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    justify-content: flex-start;\n}\n\n.sm-hub-list {\n    list-style-type: none;\n    padding-left: 0;\n    margin: 0;\n}\n\n/* Popup button styles for EditHub */\n.btn-scale-confirm {\n    background-color: #b7f88c !important;\n    color: black !important;\n}\n.btn-scale-reset {\n    background-color: #ffc445 !important;\n    color: black !important;\n}\n.btn-scale-cancel {\n    background-color: #ff2e2e !important;\n    color: black !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
